module.exports = __webpack_public_path__ + "static/media/img_socialmedia-03Msger.dc2824f2.png";